import React, { useState, useMemo } from 'react';
import './PhoneNumberHealth.css';

const US_AREA_CODES = ['201', '202', '203', '205', '206', '208', '209', '210', '212', '213', '214', '215', '216', '217', '218', '219', '301', '302', '303', '304', '305', '307', '308', '309', '310', '312', '313', '314', '315', '316', '317', '318', '319', '401', '402', '404', '405', '406', '407', '408', '409', '410', '412', '413', '414', '415', '417', '419', '501', '502', '503', '504', '505', '507', '508', '509', '510', '512', '513', '515', '516', '517', '518', '520', '601', '602', '603', '605', '606', '607', '608', '609', '610', '612', '614', '615', '616', '617', '618', '619', '701', '702', '703', '704', '706', '707', '708', '712', '713', '714', '715', '716', '717', '718', '719', '801', '802', '803', '804', '805', '806', '808', '810', '812', '813', '814', '815', '816', '817', '818', '819', '901', '903', '904', '906', '907', '908', '909', '910', '912', '913', '914', '915', '916', '917', '918', '919'];

const generateNumbers = (count) => {
  const numbers = [];
  for (let i = 0; i < count; i++) {
    const areaCode = US_AREA_CODES[Math.floor(Math.random() * US_AREA_CODES.length)];
    const middle = Math.floor(Math.random() * 800) + 200; // 200-999
    const last = Math.floor(Math.random() * 9000) + 1000; // 1000-9999
    numbers.push({
      id: i,
      number: `+1 (${areaCode}) ${middle}-${last}`,
      grade: 'A',
      status: 'Healthy',
      score: 'Low Risk',
    });
  }
  return numbers;
};

const PhoneNumberHealth = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumbers = useMemo(() => generateNumbers(3000), []);

  return (
    <div className="phone-health-container">
      <div 
        className={`phone-health-header ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="phone-health-title">
          <div className="phone-health-icon">🛡️</div>
          <div>
            <h3>Phone Number Health Monitor</h3>
            <p>3,127 Active Numbers • Third-Party Spam Scoring</p>
          </div>
        </div>
        <div className="phone-health-actions">
          <span className="health-badge">All Grade A</span>
          <svg 
            className={`dropdown-arrow ${isOpen ? 'rotated' : ''}`} 
            width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>
      
      {isOpen && (
        <div className="phone-health-dropdown">
          <div className="phone-health-grid-header">
            <span>Phone Number</span>
            <span>Spam Score</span>
            <span>Status</span>
            <span>Grade</span>
          </div>
          <div className="phone-health-list">
            {phoneNumbers.map((item) => (
              <div key={item.id} className="phone-health-row">
                <span className="phone-number">{item.number}</span>
                <span className="phone-score">{item.score}</span>
                <span className="phone-status">
                  <span className="status-dot"></span>
                  {item.status}
                </span>
                <span className="phone-grade">{item.grade}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PhoneNumberHealth;
